// CSV export utility
export function exportToCSV(rows, columns, filename) {
  if (!rows || rows.length === 0) {
    alert("No data to export");
    return;
  }
  const escape = (v) => {
    if (v === null || v === undefined) return "";
    const s = String(v).replace(/"/g, '""');
    return /[",\n]/.test(s) ? `"${s}"` : s;
  };
  const header = columns.map(c => c.label).join(",");
  const body = rows
    .map(r => columns.map(c => escape(c.get ? c.get(r) : r[c.key])).join(","))
    .join("\n");
  const csv = "\uFEFF" + header + "\n" + body; // BOM for Excel
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
